module.exports = __webpack_public_path__ + "img/v2_leaf_left.547532b5.png";